<template>
  <v-layout
    row
    wrap
    class="text-xs-center align-content-center"
    fill-height
  >
    <v-flex xs12>
      <v-progress-circular
        v-if="loading"
        indeterminate
        size="60"
        color="primary"
      />
    </v-flex>

    <v-flex
      v-if="!loading"
      xs12
      sm8
      offset-sm2
      md6
      offset-md3
    >
      <ReportsTable
        :reports="reports"
        @openReportFilesModal="openReportFilesModal"
      />
    </v-flex>
    <ReportFilesTableModal
      :visible="dialogOpen"
      :report="selectedReport"
      :files="files"
      @cancel="closeModal"
    />
  </v-layout>
</template>

<script>
import { getMisInformes, getInformeAdjuntos } from '../api/reportsEndpoints'
import { mapGetters } from 'vuex'
import ReportsTable from '../components/reports/ReportsTable'
import ReportFilesTableModal from '../components/reports/ReportFilesTableModal'

export default {
  name: 'ReportsView',
  components: {
    ReportsTable,
    ReportFilesTableModal
  },
  data () {
    return {
      dialogOpen: false,
      loading: false,
      reports: [],
      files: [],
      selectedReport: {}
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  async mounted () {
    this.loading = true
    const reports = await getMisInformes(this.user.id)
    this.reports = reports.turnos
    this.loading = false
  },
  methods: {
    async openReportFilesModal (props) {
      this.loading = true
      const files = await getInformeAdjuntos(props.informe)
      this.loading = false
      this.files = files.turnos
      this.selectedReport = props
      this.dialogOpen = true
    },
    async closeModal () {
      this.openedCancelModal = false
      this.dialogOpen = false
    }
  }
}
</script>

<style scoped>

</style>
